// Canonical printer states, shared by the Intro poller (writes), the App Out-of-Order
// overlay (reads), the checkout store (persists) and the payment-path gate
// (useTerminal). The codebase avoids TS `enum`; this `as const` object is the idiomatic
// equivalent here and gives both a value namespace (PrinterState.OFFLINE) and a type.
export const PrinterState = {
  READY: 'READY',
  PAPER_NEAR_EMPTY: 'PAPER_NEAR_EMPTY',
  OFFLINE: 'OFFLINE',
  COVER_OPEN: 'COVER_OPEN',
  NO_PAPER: 'NO_PAPER',
  UNKNOWN_ERROR: 'UNKNOWN_ERROR'
} as const

// eslint-disable-next-line @typescript-eslint/no-redeclare -- value + type intentionally share the name (enum-like)
export type PrinterState = (typeof PrinterState)[keyof typeof PrinterState]

// States in which the kiosk must NOT take a payment — there is no printable receipt.
export type BlockingPrinterState = Exclude<PrinterState, typeof PrinterState.READY | typeof PrinterState.PAPER_NEAR_EMPTY>
